<template>
  <!-- 首页 -->
  <div class="conMain">
    <casousel :carousel_list="carousel_list"></casousel>
    <h1 class="seo-title">纳微创新科研检测一站式服务平台</h1>
    <div class="list_main">
      <div class="suspension">
        <div v-for="(item,index) in carousel_list_menu" :key="index" class="suspension_item" @click="menuHandle(item)">
          <div class="left">
            <img
              :src="getSuspensionImage(item)"
              :alt="getSuspensionAlt(item)"
              @error="setSuspensionFallback"
              srcset=""
            >
          </div>
          <div class="center">
            <div class="center_title">{{ item.realteTitle }}</div>
            <div class="center_desc">{{ item.realteDesc }}</div>
          </div>
          <div class="right">
            <img src="../../assets/img/home_backgroud_right.png" alt="" srcset="">
          </div>
        </div>
      </div>
      <div class="commonTitle">
        <h3 class="itemTitle">热门设备</h3>
        <div class="subTitle">自营设备品类丰富，高效快捷</div>
      </div>
      <div class="cardList">
        <el-row :gutter="70" type="flex" style="flex-wrap: wrap">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-for="(i, index) in equipList" :key="i + index + 'a'">
            <equipment-card
              :equipment="i"
              :image-prefix="imgurl"
              :animated="false"
              @details="detailsHandle"
              @action="toAppoint"
            />
          </el-col>
        </el-row>
        <div class="tab_equip_box" v-if="total > 8">
          <div class="tab_equip" :class="{ activeClass: activeIndex == index }" @click="selectTab(index)"
            v-for="(item, index) in 2" :key="item + index"></div>
        </div>
      </div>
    </div>
    <div class="list_main serveFlow">
      <div class="commonTitle">
        <h3 class="itemTitle">服务流程</h3>
        <div class="subTitle">一对一定制，专业化检测，可视化报告</div>
      </div>
      <div class="cardList">
        <div class="serveList">
          <el-row type="flex" style="flex-wrap: wrap">
            <el-col v-for="item in serveList" :key="item.index" :span="4" class="serve_col">
              <div class="serve_top">
                <div class="serve_line first_line"></div>
                <div>
                  <img src="../../assets/img/bz.png" alt="" />
                </div>
                <div class="serve_line second_line"></div>
              </div>
              <div class="serveFlow_card">
                <img class="serveFlow_img" :src="item.src" :alt="item.alt" />
                <div class="euqipName">{{ item.name }}</div>
                <div class="otherNums">{{ item.otherWord }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="list_main">
      <div class="commonTitle">
        <h3 class="itemTitle">服务项目</h3>
        <div class="subTitle">多维技术支持，一站式科研检测服务</div>
      </div>
      <div class="cardList">
        <div class="serveList">
          <el-row type="flex" style="flex-wrap: wrap">
            <el-col v-for="item in serveProList" :key="item.index" :span="8" class="serve_col">
              <div class="servePro_card">
                <img class="servePro_img" :src="item.src" :alt="item.alt" />
                <div class="euqipName">{{ item.name }}</div>
                <div class="otherNums">
                  {{ item.otherWord1 }}
                  <el-divider direction="vertical"></el-divider>
                  {{ item.otherWord2 }}
                  <br />
                  {{ item.otherWord3 }}
                  <el-divider direction="vertical"></el-divider>
                  {{ item.otherWord4 }}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="list_main map_main">
      <div class="commonTitle">
        <h3 class="itemTitle">平台优势</h3>
        <div class="subTitle">
          价值超亿元大型共享设备，10大科研板块，500余种检测项目，自营实验室布局全国
        </div>
      </div>
      <div class="map_content">
        <div ref="openingChart" style="height: 750px"></div>
        <div class="mapTooltip" v-if="mapData.name != '南海群岛'">
          <div class="mapName">{{ mapData.name }}办事处</div>
          <div class="mapPhone"><img src="../../assets/img/phone.png" alt="服务热线图标" />400-168-0661</div>
        </div>
      </div>
    </div>
    <div class="nums_main" id="nums_main">
      <el-row type="flex" style="flex-wrap: wrap">
        <el-col :span="6" class="nums_col">
          <div class="numsData first_nums">
            <div class="nums_first_font_size">10000000万</div>
            <div>科研设备</div>
          </div>
        </el-col>
        <el-col :span="6" class="nums_col">
          <div class="numsData numsDataOther">
            <div class="nums_font_size">100000位</div>
            <div class="nums_font_Name">年服务人数</div>
          </div>
        </el-col>
        <el-col :span="6" class="nums_col">
          <div class="numsData numsDataOther">
            <div class="nums_font_size">50万份</div>
            <div class="nums_font_Name">年样品检测数量</div>
          </div>
        </el-col>
        <el-col :span="6" class="nums_col">
          <div class="numsData numsDataOther">
            <div class="nums_font_size">800家</div>
            <div class="nums_font_Name">合作伙伴</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="list_main member_main">
      <div class="commonTitle">
        <h3 class="itemTitle">纳微会员</h3>
        <div class="subTitle">实力国企，源于品质的信赖</div>
      </div>
      <div class="member_img_list">
        <div class="left">
          <div class="left_top"><img src="../../assets/img/hy3.png" alt="纳微创新会员服务展示" /></div>
          <div class="left_content_container">
            <div class="left_content">
              <div class="content_item" v-for="(i, index) in scrollLeft[0]" :key="index">
                <div class="title">{{ i.title }}</div>
                <div class="name">{{ i.name }}</div>
                <div class="time">{{ i.time }}</div>
                <div class="pay">{{ i.pay }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="right_left"><img src="../../assets/img/hy4.png" alt="纳微创新会员合作展示" /></div>
          <div class="right_content_container">
            <div class="right_content">
              <div class="content_item" v-for="(i, index) in scrollRight" :key="index">
                <div class="title">{{ i.title }}</div>
                <div class="name">{{ i.name }}</div>
                <div class="time">{{ i.time }}</div>
                <div class="pay">{{ i.pay }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import casousel from "./Carousel";
import equipmentCard from "@/components/equipmentCard.vue";
import china from "../../plugins/china.json";
import { hotItemList } from "@/api/request";
import { left, right } from "./scrollList";
import { carouselList } from "@/api/request"

export default {
  components: { casousel, equipmentCard },
  data() {
    return {
      imgurl: process.env.VUE_APP_FILE_API,
      activeIndex: 0,
      pageSize: 8,
      pageNum: 1,
      total: 0,
      carouselInfo: {},
      mapData: {
        name: "长沙",
      },
      carousel_list: [],//banner图列表
      carousel_list_menu : [],//按钮列表
      mapAddressData: [
        { name: "太原", value: [112.53, 37.87], labelColor: "#333", fontSize: "12px" },
        { name: "西安", value: [108.95, 34.27], labelColor: "#333", fontSize: "12px" },
        { name: "合肥", value: [117.27, 31.86], labelColor: "#333", fontSize: "12px" },
        { name: "武汉", value: [114.3055, 30.5928], labelColor: "#333", fontSize: "12px" },
        { name: "杭州", value: [120.1551, 30.2741], labelColor: "#333", fontSize: "12px" },
        { name: "重庆", value: [106.5516, 29.563], labelColor: "#333", fontSize: "12px" },
        { name: "南昌", value: [115.8582, 28.6829], labelColor: "#333", fontSize: "12px" },
        { name: "长沙", value: [112.9389, 28.2278], labelColor: "#4d6fff", fontSize: "16px" },
        { name: "贵阳", value: [106.6302, 26.647], labelColor: "#333", fontSize: "12px" },
        { name: "昆明", value: [102.8329, 24.8801], labelColor: "#333", fontSize: "12px" },
        { name: "南宁", value: [108.366, 22.8172], labelColor: "#333", fontSize: "12px" },
        { name: "广州", value: [113.2644, 23.1291], labelColor: "#333", fontSize: "12px" },
        { name: "福州", value: [119.2965, 26.0745], labelColor: "#333", fontSize: "12px" },
        { name: "南海群岛", value: [128.2965, 20.0745], labelColor: "#333", fontSize: "12px" },
        // { name: "南海群岛", value: [118.2965, 26.0745],labelColor: '#333',fontSize: '12px' },
      ],
      equipList: [],
      serveList: [
        {
          name: "客户注册",
          src: require("../../assets/img/khzc.png"),
          alt: "科研检测服务流程-客户注册",
          otherWord: "进行网站注册提升测试效率",
        },
        {
          name: "加入会员",
          src: require("../../assets/img/jrhy.png"),
          alt: "科研检测服务流程-加入会员",
          otherWord: "加入纳微会员享受千元优惠",
        },
        {
          name: "填写需求",
          src: require("../../assets/img/txxq.png"),
          alt: "科研检测服务流程-填写需求",
          otherWord: "测试确定项目填写测试需求",
        },
        {
          name: "完成支付",
          src: require("../../assets/img/wczf.png"),
          alt: "科研检测服务流程-完成支付",
          otherWord: "核对测试费用完成订单支付",
        },
        {
          name: "打印详情",
          src: require("../../assets/img/dyxq.png"),
          alt: "科研检测服务流程-打印详情",
          otherWord: "打印详情",
        },
        {
          name: "结果评价",
          src: require("../../assets/img/jgpj.png"),
          alt: "科研检测服务流程-结果评价",
          otherWord: "下载测试结果进行结果评估",
        },
      ],
      serveProList: [
        {
          name: "材料测试",
          src: require("../../assets/img/clcs.png"),
          alt: "材料表征检测服务项目",
          otherWord1: "扫描电子显微镜(SEM)",
          otherWord2: "电子显微镜(TEM)",
          otherWord3: "射线光电子能谱(XPS)",
          otherWord4: "比表面及分析(BET)",
        },
        {
          name: "生物电路",
          src: require("../../assets/img/swdl.png"),
          alt: "生物电镜检测服务项目",
          otherWord1: "生物扫描电镜(SEM)",
          otherWord2: "生物电镜(TEM)",
          otherWord3: "八飞",
          otherWord4: "活体影像",
        },
        {
          name: "环境检测",
          src: require("../../assets/img/hjjc.png"),
          alt: "环境检测服务项目",
          otherWord1: "扫常规水质分析",
          otherWord2: "土壤肥力测试",
          otherWord3: "固体废物检测",
          otherWord4: "大气样品检测",
        },
        {
          name: "模拟计算",
          src: require("../../assets/img/mnjs.png"),
          alt: "模拟计算服务项目",
          otherWord1: "第—性原理",
          otherWord2: "分子动力学",
          otherWord3: "有限元模拟",
          otherWord4: "量子化学",
        },
        {
          name: "科研绘图",
          src: require("../../assets/img/kyht.png"),
          alt: "科研绘图服务项目",
          otherWord1: "封面图",
          otherWord2: "摘要图",
          otherWord3: "插图",
          otherWord4: "动画",
        },
        {
          name: "数据分析",
          src: require("../../assets/img/sjfx.png"),
          alt: "数据分析服务项目",
          otherWord1: "XPS数据分析",
          otherWord2: "XRD数据分析",
          otherWord3: "金属失效分析",
          otherWord4: "单晶数据解析",
        },
        {
          name: "论文润色",
          src: require("../../assets/img/lwrs.png"),
          alt: "论文润色服务项目",
          otherWord1: "中文论文润色",
          otherWord2: "中文学术翻译",
          otherWord3: "SCl论文投稿",
          otherWord4: "SCI论文查重",
        },
        {
          name: "试剂耗材",
          src: require("../../assets/img/sjhc.png"),
          alt: "试剂耗材服务项目",
          otherWord1: "石墨烯",
          otherWord2: "碳纳米管",
          otherWord3: "金属有机框架材米料MOF",
          otherWord4: "氧钛金属碳",
        },
        {
          name: "纳微学院",
          src: require("../../assets/img/nwxy.png"),
          alt: "纳微学院服务项目",
          otherWord1: "模拟计算·直播课",
          otherWord2: "科研绘图·直播课",
          otherWord3: "金属有机框架材米料MOF",
          otherWord4: "氧钛金属碳",
        },
      ],
      scrollLeft: [],
      scrollRight: [],
    };
  },
  watch: {
    $route: {
      deep: true, // 深度监听
      handler() {
        // this.activeIndex = this.$route.query.type;
      },
    },
  },
  created() {
    carouselList({ type: 1, ifShow: 1,categoryType: 1 }).then(res => {
      this.carousel_list = res.rows
      this.carousel_list_menu = res.rows.filter(item => {
        // skipStatus == 0   时，可以点击跳转
        // if(item.skipStatus == 0) {
          return item
        // }
      })
    })
  },
  mounted() {
    this.scrollLeft = left;
    this.scrollRight = right;
    this.initCharts();
    this.getList();
  },
  methods: {
    getSuspensionImage(item) {
      const fallbackImage = require("../../assets/img/morentupian.png");
      const imagePath = item && item.realtePic ? String(item.realtePic).trim() : "";

      if (!imagePath) {
        return fallbackImage;
      }

      if (
        /^(https?:)?\/\//.test(imagePath) ||
        imagePath.startsWith("data:") ||
        imagePath.startsWith("blob:") ||
        imagePath.startsWith("/dev-file") ||
        imagePath.startsWith("/prod-file")
      ) {
        return imagePath;
      }

      return `${this.imgurl}${imagePath.startsWith("/") ? "" : "/"}${imagePath}`;
    },
    getSuspensionAlt(item) {
      const title = item.realteTitle || item.title || "首页服务入口";
      const desc = item.realteDesc ? `-${item.realteDesc}` : "";

      return `纳微创新${title}${desc}`;
    },
    setSuspensionFallback(event) {
      event.target.src = require("../../assets/img/morentupian.png");
    },
    menuHandle(item) {
      let len = 32
      let strVals = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; // 剔除了易混淆的字符oOLl,9gq,Vv,Uu,I1
      let maxLen = strVals.length;
      let randomStr = '';
      for (var i = 0; i < len; i++) {
        randomStr += strVals.charAt(Math.floor(Math.random() * maxLen));
      }
      if(item.skipStatus == 0) {
        if(item.skipType == 1) {
          this.$router.push({
            path: item.skipPage,
            query: { source: 'banner',key: randomStr}
          });
        } else if(item.skipType == 2) {
          this.$router.push({
            path: "/carouselDetail",
            query: { source: 'banner',key: randomStr, title: item.title, content: item.content}
          });
        } else if(item.skipType == 3) {
          this.$router.push({
            path: "/carouselDetail",
            query: { source: 'banner',key: randomStr, skipPic: item.skipPic}
          });
        } else if(item.skipType == 4) {
          window.open(item.skipPage, '_blank')
        }
      } else {
      }
    },
    getList() {
      hotItemList({
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      }).then((res) => {
        this.equipList = res.rows;
        this.total = res.total;
      });
      this.$forceUpdate();
    },
    initCharts() {
      let that = this;
      // 初始化中国地图
      this.$echarts.registerMap("china", china);
      // 获取dom节点
      let openingChart = this.$echarts.init(this.$refs.openingChart);
      // option配置写在最下面的
      openingChart.setOption({
        backgroundColor: "#E3EAF7",
        series: [
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            focus: "self",
            data: that.mapAddressData.map((item) => ({
              name: item.name,
              value: item.value,
              label: {
                show: true,
                formatter: "{b}",
                position: "right",
                color: item.labelColor, // 初始的标签颜色
                fontSize: item.fontSize,
              },
            })),
            itemStyle: {
              normal: {
                color: "rgba(0, 128, 255, 0.7)", // 修改标注点的颜色
                symbol: "circle", // 修改标注点的形状
                symbolSize: 5, // 修改标注点的大小
              },
            },
            emphasis: {
              label: {
                textStyle: {
                  color: "#4d6fff",
                  fontSize: "16px",
                  fontWeight: 500,
                },
              },
            },
          },
        ],
        geo: {
          map: "china",
          roam: false, // 禁止拖动和缩放
          zoom: 1.7, // 初始缩放级别
          center: [104, 37], // 初始中心点经纬度
          top: "8%",
          itemStyle: {
            normal: {
              areaColor: "#CDDCE6", // 区域颜色
              borderColor: "#A6ADB1", // 区域边框颜色
            },
            emphasis: {
              areaColor: "#CDDCE6", //鼠标滑过区域颜色
              label: {
                show: false,
              },
            },
          },
          label: {
            show: false,
            emphasis: {
              show: false,
            },
          },
        },
      });
      // 监听标记点点击事件
      openingChart.on("click", function (params) {
        if (params.componentSubType === "effectScatter") {
          // 在这里执行点击标记点后的操作
          that.mapData.name = params.data.name;
        }
      });
      // 监听标记点点击事件
      openingChart.on("click", function (params) {
        if (params.componentSubType === "effectScatter") {
          openingChart.setOption({
            series: [
              {
                type: "effectScatter",
                data: that.mapAddressData.map((item, index) => ({
                  name: item.name,
                  value: item.value,
                  label: {
                    show: true,
                    formatter: "{b}",
                    position: "right",
                    color: params.dataIndex == index ? "#4d6fff" : "#333",
                    fontSize: params.dataIndex == index ? "16px" : "12px",
                  },
                })),
              },
            ],
          });
        }
      });
      window.addEventListener("resize", () => {
        openingChart.resize();
      });
    },
    detailsHandle(i) {
      this.$router.push({
        path: "/equipDetails",
        query: { id: i.id, type: this.$route.query.type ? this.$route.query.type : 0 },
      });
    },
    selectTab(index) {
      this.activeIndex = index;
      document.documentElement.scrollTop = 700;
      if (index == 0) {
        this.pageNum = 1;
      } else {
        this.pageNum = 2;
      }
      this.getList();
    },
    // 未登录时进入登录页，成功后继续打开当前设备的预约页面
    toAppoint(i) {
      const appointRoute = this.$router.resolve({
        path: "/appointPage",
        query: {
          id: i.id,
          type: this.$route.query.type ? this.$route.query.type : 0,
        },
      }).route.fullPath;
      if(this.$store.getters.token) {
        this.$router.push(appointRoute);
        return;
      }
      this.$router.push({
        path: "/login",
        query: {
          redirect: appointRoute,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.seo-title {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.serveFlow {
  background: url("../../assets/img/bg1.png") no-repeat;
  background-size: 100% 100%;
  padding-bottom: 100px;
  margin-top: 50px;
}

.serveFlow_card {
  background: #fff;
  border-radius: 7px;
  text-align: center;
  padding-bottom: 30px;
  margin-right: 10px;
  margin-left: 10px;
  margin-top: 40px;
}

.serveFlow_img {
  width: 60%;
  margin: 25px;
}

.serveList {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}

.serve_top {
  .serve_line {
    width: 48%;
    border-top: 2px dashed #979797;
    margin-top: 10px;
  }

  margin-right: 5px;
  display: flex;
  flex-flow: row nowrap;
  position: relative;
  text-align: center;

  img {
    width: 50%;
  }
}

.serve_col:first-child .first_line {
  border-top: none;
}

.serve_col:last-child .second_line {
  border-top: none;
}

.servePro_img {
  width: 120px;
  height: 105px;
}

.servePro_card {
  height: 230px;
  display: flex;
  flex-flow: column;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 50px;
}

.map_main {
  background: url("../../assets/img/mapbg.png") no-repeat;
  background-size: 100% 100%;
  padding-bottom: 100px;
}

.map_content {
  position: relative;
}

.mapTooltip {
  position: absolute;
  width: 350px;
  height: 140px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 7px;
  top: 200px;
  left: 200px;
  padding: 20px;
}

.mapName {
  color: #4d6fff;
  padding: 20px;
  font-size: 22px;
}

.mapPhone {
  border-top: 1px dashed #979797;
  padding: 20px;
  font-size: 18px;
  display: flex;
  align-items: center;

  img {
    width: 30px;
    height: 30px;
    margin-right: 20px;
  }
}

.nums_main {
  width: 80%;
  margin: 50px auto;
  padding-bottom: 50px;
}

.nums_col {
  display: flex;
  justify-content: center;
  align-items: center;
}

.numsData {
  width: 220px;
  height: 220px;
  border-radius: 50%;
  line-height: 45px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.nums_first_font_size {
  font-size: 32px;
}

.nums_font_size {
  font-size: 32px;
  color: #4a88ff;
}

.nums_font_Name {
  color: #5a5a5a;
}

.first_nums {
  background: #558bf7;
  color: #fff;
}

.numsDataOther {
  box-shadow: 0px 9px 33px 0px rgba(0, 0, 0, 0.07);
}

.member_main {
  width: 100%;
  min-width: 1200px;
  padding-bottom: 100px;
  background: #e3eaf7;
}

.member_img_list {
  // width: 80%;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  .left {
    width: 560px;
    display: flex;
    flex-direction: column;

    .title {
      margin-left: 10px;
    }
  }

  .right {
    display: flex;
    width: 560px;
    flex-direction: column;
    text-align: center;

    .title {
      // margin-left: -20px;
      padding-left: 10px;
    }
  }

  .left_content_container {
    width: 536px;
    /* 或固定宽度 */
    height: 400px;
    /* 容器的高度 */
    overflow: hidden;
    position: relative;
    margin-left: 2px;
    margin-top: -3px;
  }

  .right_content_container {
    width: 536px;
    /* 或固定宽度 */
    height: 400px;
    /* 容器的高度 */
    overflow: hidden;
    position: relative;
    margin-left: 2px;
    margin-top: -3px;
  }

  .left_content {
    width: 520px;
    // height: 8000px;
    background: #ffffff;
    margin-left: 20px;
    list-style: none;
    padding: 0;
    position: absolute;
    animation: scroll-animation 250s linear infinite;
    /* 调整时间以控制滚动速度 */
  }

  /* 定义关键帧动画 */
  @keyframes scroll-animation {
    from {
      top: 0;
    }

    to {
      top: -6000px;
      /* 假设列表总高度恰好是容器高度的两倍 */
    }
  }

  .right_content {
    width: 520px;
    background: #ffffff;
    margin-left: 20px;
    margin-top: -3px;
    list-style: none;
    padding: 0;
    position: absolute;
    animation: scroll-animation 250s linear infinite;
    /* 调整时间以控制滚动速度 */
  }

  .content_item {
    width: 520px;
    overflow: hidden;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px dashed #d9d9d9;

    // padding: 5px 5px;
    .title {
      width: 220px;
      white-space: nowrap;
      /* 防止文本换行 */
      overflow: hidden;
      /* 隐藏溢出的内容 */
      text-overflow: ellipsis;
      /* 在溢出的地方显示省略号 */
    }

    .name {
      width: 80px;
    }

    .time {
      width: 100px;
    }

    .pay {
      width: 100px;
    }
  }

  img {
    width: 560px;
  }
}

.tab_equip {
  width: 70px;
  height: 10px;
  background: #e4ebf8;
  cursor: pointer;
}

.tab_equip_box {
  margin: 20px auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 150px;
}

.activeClass {
  background: #558bf7;
}

.suspension {
  display: flex;
  width: 1920px;
  margin: 20px auto;
  justify-content: space-between;

  .suspension_item:hover {
    box-shadow: #dddddd 8px 8px 10px;
    
  }

  .suspension_item {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 280px;
    height: 112px;
    cursor: pointer;
    background-image: url('../../assets/img/home_backgroud.png');
    background-size: cover;
    background-position: center;

    .left {
      width: 60px;

      img {
        width: 60px;
        height: 54px;
      }
    }

    .center {
      .center_title {
        font-weight: 700;
        font-size: 20px;
        color: #333333;
      }

      .center_desc {
        font-size: 13px;
        color: #666666;
        padding-top: 3px;
      }
    }

    .right {
      width: 30px;
      height: 30px;

      img {
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>
